module.exports = __webpack_public_path__ + "img/circle-arrow.bfa28a56.png";